"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Tick.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Tick = function Tick(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 17.73 18.33"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Tick Icon"), _react2.default.createElement("path", {
    className: "tick",
    d: "M17.3 1.12L16.24.26a1.18 1.18 0 0 0-1.65.17L5.71 13.26 3.15 10.1a1.19 1.19 0 0 0-1.66-.17l-1 .85a1.19 1.19 0 0 0-.17 1.66l4.46 5.48a1.82 1.82 0 0 0 1.93.22s.38-.12 1.48-1.89l9.28-13.49a1.18 1.18 0 0 0-.17-1.64z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = Tick;